import { OPTIONS_POLL_TIMEOUT_MS } from "@/lib/query-constants";

import type { MarketplaceOrderStatus } from "../types/marketplace.types";

/** How long in-flight handoffs show a loader before surfacing a retry message. */
export const ORDER_HANDOFF_SLOW_THRESHOLD_MS = OPTIONS_POLL_TIMEOUT_MS;

export const ORDER_HANDOFF_POLL_INTERVAL_MS = 2_000;

export const ORDER_HANDOFF_SUCCESS_VISIBLE_MS = 5_000;

export function isInFlightHandoffStatus(status: MarketplaceOrderStatus): boolean {
  return status === "PENDING_SEND" || status === "SENDING";
}

export function hasInFlightHandoffOrders(
  orders: readonly { status: MarketplaceOrderStatus }[] | undefined,
): boolean {
  return orders?.some((order) => isInFlightHandoffStatus(order.status)) ?? false;
}

export function elapsedMsSince(isoTimestamp: string, nowMs = Date.now()): number {
  return Math.max(0, nowMs - new Date(isoTimestamp).getTime());
}

export function isHandoffSlowPending(isoTimestamp: string, nowMs = Date.now()): boolean {
  return elapsedMsSince(isoTimestamp, nowMs) >= ORDER_HANDOFF_SLOW_THRESHOLD_MS;
}
